import { render, staticRenderFns } from "./LegalExpertClaims.vue?vue&type=template&id=6e4f42ad&scoped=true"
import script from "./LegalExpertClaims.vue?vue&type=script&lang=js"
export * from "./LegalExpertClaims.vue?vue&type=script&lang=js"
import style0 from "./LegalExpertClaims.vue?vue&type=style&index=0&id=6e4f42ad&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4f42ad",
  null
  
)

export default component.exports